function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M0 0H32V32H0z",
  transform: "translate(-805 -850) translate(0 832) translate(805 18)"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#000",
  fillRule: "nonzero",
  transform: "translate(-805 -850) translate(0 832) translate(805 18) translate(8 8)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 2.74,
  height: 1,
  x: 2.528,
  y: 12.592,
  rx: 0.5
}), /*#__PURE__*/React.createElement("rect", {
  width: 7.895,
  height: 1,
  x: 2.528,
  y: 5.036,
  rx: 0.5
}), /*#__PURE__*/React.createElement("rect", {
  width: 7.895,
  height: 1,
  x: 2.528,
  y: 2.519,
  rx: 0.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.696 4.327c-.195-.195-.459-.304-.734-.304-.276 0-.54.11-.734.304l-5.8 5.806 1.469 1.47 5.799-5.806c.406-.406.406-1.064 0-1.47zM6.4 10.9l.827-.825h-4.56c-.078 0-.14.063-.14.14v.606c0 .078.062.142.14.143h3.719L6.4 10.9zM9.742 7.556H2.667c-.078 0-.14.062-.14.14v.608c0 .078.062.14.14.14h6.186l.89-.888z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.062 10.688v4.423H.89V.89h11.173v4.347l.89-.89V.673c0-.371-.302-.672-.673-.672H.672C.301 0 0 .3 0 .672v14.656c0 .371.3.672.672.672h11.607c.371 0 .672-.3.672-.672V9.799l-.889.889z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.979 10.576l-.66.66c-.063.062-.105.143-.12.23l-.266 1.482c-.007.039.006.079.034.107.028.028.068.04.107.033l1.482-.263c.088-.017.168-.059.232-.121l.66-.66-1.47-1.468z"
}))))));

var SvgDescription = function SvgDescription(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDescription, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/description.7c26cc66.svg";
export { ForwardRef as ReactComponent };